import {Injectable} from '@angular/core';
import {LocalStorageEnum} from '../../enums/utils';
import {ICredentials} from '../../interfaces/credentials';
import {IUser} from '../../models/auth';
import {AnyObject} from '../../interfaces/utils';

@Injectable({
  providedIn: 'root',
})
export class StorageService {

  private util = {
    printUserAuth: true,
  };
  constructor() { }

  setSessionItem = <T>(key: string, value: T): void => {
    const objetString: string = JSON.stringify(value);
    sessionStorage.setItem(key, objetString);
  }

  getSessionItem = <T>(key: string): T => {
    try {
      const objString = sessionStorage.getItem(key);
      return JSON.parse(objString);
    } catch (e) {
      return undefined;
    }
  }

  existsInSession = (key: string): boolean => {
    return sessionStorage.getItem(key) !== null;
  }

  clearSession = () => {
    sessionStorage.clear();
  }

  setLocalItem = <T>(key: LocalStorageEnum | string, value: T): void => {
    const objString: string = JSON.stringify(value);
    localStorage.setItem(key, objString);
    // solo para pruebas, para saber con que usuario ocurren los errores
    if (key === 'user') {
      if (!value || !(value as ICredentials).user) return;
      this.showUserInfo((value as ICredentials).user);
    }
  }

  getLocalItem = <T>(key: LocalStorageEnum | string): T => {
    try {
      const objString = localStorage.getItem(key);
      return JSON.parse(objString);
    } catch (e) {
      return undefined;
    }
  }

  removeLocalItem = <T>(key: LocalStorageEnum | string): void => {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.log('[removeLocalItem] ', e);
    }
  }

  existsInLocal = (key: LocalStorageEnum | string): boolean => {
    return localStorage.getItem(key) !== null;
  }

  clearAll = (): void => {
    localStorage.clear();
  }

  /**
   * Method used for development
   * @param user
   * @private
   */
  private showUserInfo(user: IUser): void {
    if (!this.util.printUserAuth) return;

    const userInfo: AnyObject = {
      user: {email: user.email, _id: user._id},
      expertId: user.experts?.length ? user.experts[0]._id : undefined,
      patientId: user.patients?.length ? user.patients[0]._id : undefined,
    };
    console.log(`[AUTH] ${JSON.stringify(userInfo)}`);
    this.util.printUserAuth = false;
  }
}
